export const Role = {
  /**
   * Admin
   */
  Admin: 'ROLE_ADMIN',
  /**
   * Liftbook operator
   */
  Operator: 'ROLE_OPERATOR',
  /**
   * Liftbook manager
   */
  Manager: 'ROLE_MANAGER',
  /**
   * Liftbook worker
   */
  Worker: 'ROLE_WORKER',
  /**
   * Display advertiser
   */
  Master: 'ROLE_CUSTOMER_MASTER',
  /**
   * Display employee
   */
  ViewEmployee: 'ROLE_VIEW_EMPLOYEE',
  /**
   * Display facility manager
   */
  FacilityManager: 'ROLE_FACILITY_MANAGER'
}
